import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { Avatar } from '../components/Avatar';
import { Input } from '../components/Input';
import { Button } from '../components/Button';
import { SendIcon } from 'lucide-react';
export const Conversation = () => {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  // Mock conversation data
  const conversation = {
    id: id,
    user: {
      id: 'u1',
      name: 'Sarah Johnson',
      avatar: 'https://randomuser.me/api/portraits/women/12.jpg'
    },
    event: 'Summer Club Night',
    messages: [{
      id: 'm1',
      text: "Hi there! I'm interested in joining your table for the Summer Club Night event.",
      sender: 'them',
      timestamp: '10:15 AM'
    }, {
      id: 'm2',
      text: 'Hello! Thanks for reaching out. We have a couple of spots available.',
      sender: 'me',
      timestamp: '10:18 AM'
    }, {
      id: 'm3',
      text: "Great! I'll be coming with a friend. We're both excited for the event.",
      sender: 'them',
      timestamp: '10:20 AM'
    }, {
      id: 'm4',
      text: "Perfect! I've accepted your request. Looking forward to meeting you both.",
      sender: 'me',
      timestamp: '10:22 AM'
    }, {
      id: 'm5',
      text: 'Thanks for accepting my request! Looking forward to the event.',
      sender: 'them',
      timestamp: '10:23 AM'
    }]
  };
  const handleBack = () => {
    navigate('/messages');
  };
  const handleSend = () => {
    if (message.trim()) {
      // Would handle sending the message here
      console.log('Sending message:', message);
      setMessage('');
    }
  };
  return <div className="bg-white min-h-screen pb-16" data-id="element-254">
      <Header title={conversation.user.name} onBack={handleBack} data-id="element-255" />
      <div className="p-4 border-b border-gray-200" data-id="element-256">
        <div className="flex items-center" data-id="element-257">
          <Avatar name={conversation.user.name} alt={conversation.user.name} src={conversation.user.avatar} size="md" data-id="element-258" />
          <div className="ml-3" data-id="element-259">
            <h3 className="font-medium text-gray-800" data-id="element-260">
              {conversation.user.name}
            </h3>
            <p className="text-xs text-gray-600" data-id="element-261">{conversation.event}</p>
          </div>
        </div>
      </div>
      <div className="flex flex-col p-4 h-[calc(100vh-200px)] overflow-y-auto" data-id="element-262">
        {conversation.messages.map(msg => <div key={msg.id} className={`max-w-[80%] mb-4 ${msg.sender === 'me' ? 'self-end' : 'self-start'}`} data-id="element-263">
            <div className={`p-3 rounded-lg ${msg.sender === 'me' ? 'bg-gray-200 text-gray-800 rounded-br-none' : 'border border-gray-300 text-gray-800 rounded-bl-none'}`} data-id="element-264">
              {msg.text}
            </div>
            <div className={`text-xs text-gray-500 mt-1 ${msg.sender === 'me' ? 'text-right' : 'text-left'}`} data-id="element-265">
              {msg.timestamp}
            </div>
          </div>)}
      </div>
      <div className="fixed bottom-16 left-0 right-0 bg-white border-t border-gray-200 p-3" data-id="element-266">
        <div className="flex items-center" data-id="element-267">
          <Input placeholder="Type a message..." value={message} onChange={e => setMessage(e.target.value)} className="flex-1" data-id="element-268" />
          <Button variant="primary" onClick={handleSend} className="ml-2" disabled={!message.trim()} data-id="element-269">
            <SendIcon className="h-5 w-5" data-id="element-270" />
          </Button>
        </div>
      </div>
      <Navigation data-id="element-271" />
    </div>;
};